/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-layer-popover-arrow-padding: 0px;
  --nve-sys-layer-popover-arrow-offset: 0px;
  --nve-sys-layer-popover-offset: var(--nve-ref-space-xl);
  --box-shadow: var(--nve-ref-shadow-200);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

[internal-host] {
  display: flex;
  flex-direction: column-reverse;
  gap: var(--nve-ref-space-sm);
}

::slotted(nve-notification) {
  position: relative;
  translate: none;
  margin: 0;
  position-anchor: initial !important;
}
